import React from 'react';
import { ListItem } from 'src/components/list-item';

import type { Category } from '../../types';
import { RelatedResourcesList } from './styles';

interface SubCategoryListProps {
  categories: Category[];
  collapse?: boolean;
}

const SubCategoryList: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<SubCategoryListProps>>
> = ({ categories, collapse }) => (
  <RelatedResourcesList collapse={collapse}>
    {categories.map(category => (
      <ListItem
        key={category.id}
        name={category.name}
        link={category.pathName}
        showArrow
      />
    ))}
  </RelatedResourcesList>
);

export default SubCategoryList;
